import type { RouteLocationRaw } from 'vue-router'

export type Search = {
  name: string
  entity: SearchEntity
  score: number
  customerId: string | null
  subscriptionId: string | null
  partnerId: string | null
  matchedKey: SearchMatchedKey | null
  matchedValue: string | null
}

export enum SearchEntity {
  PARTNER = 'partner',
  CUSTOMER = 'customer',
  SUBSCRIPTION = 'subscription',
  RESELLER = 'reseller',
}

export enum SearchMatchedKey {
  customerName = 'customerName',
  customerEmail = 'customerEmail',
  subscriptionName = 'subscriptionName',
  accountOwnerEmail = 'accountOwnerEmail',
  poNumber = 'poNumber',
  opportunityId = 'opportunityId',
  chargebeeOrderId = 'chargebeeOrderId',
  vatNumber = 'vatNumber',
  partnerName = 'partnerName',
  partnerEmail = 'partnerEmail',
  partnerInvoiceEmail = 'partnerInvoiceEmail',
  salesforceCustomerId = 'salesforceCustomerId',
  billingVatNumber = 'billingVatNumber',
  resellerName = 'resellerName',
  resellerEmail = 'resellerEmail',
  resellerInvoiceEmail = 'resellerInvoiceEmail',
}

export type SearchItemMatch = {
  key: SearchMatchedKey
  value: string
}

export type SearchItem = {
  id: string
  label: string
  entity: SearchEntity
  description?: string
  rightText?: string
  tag?: string
  icon?: string
  to?: RouteLocationRaw
  match?: SearchItemMatch
  partnerId?: string | null
}

export type SearchSection = {
  id: string
  label: string
  items: SearchItem[]
}
